export enum FundAccountType {
    ACTIVE = 'ACTIVE',
    PASSIVE = 'PASSIVE',
}